import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions } from 'vuex';
import { timeFix } from '@/utils/util';
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import JGraphicCode from '@/components/jeecg/JGraphicCode';
import { getAction } from '@/api/manage';
import { encryption } from '@/utils/encryption/aesEncrypt';
import UserPassword from "./UserPassword";
import loginImg from '@/assets/others/login/iot2.png';
import sx_code from '@/assets/others/login/sx_code.png';
import ThirdLogin from "./third/ThirdLogin";
export default {
  components: {
    JGraphicCode: JGraphicCode,
    UserPassword: UserPassword,
    ThirdLogin: ThirdLogin
  },
  data: function data() {
    return {
      isSx: false,
      waterName: '',
      titleLogo: '',
      loginImg: loginImg,
      appQr: sx_code,
      customActiveKey: 'tab1',
      loginBtn: false,
      loginType: 0,
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      form: this.$form.createForm(this),
      state: {
        time: 60,
        smsSendBtn: false
      },
      formLogin: {
        username: '',
        password: '',
        captcha: '',
        mobile: '',
        rememberMe: true
      },
      validatorRules: {
        username: {
          rules: [{
            required: true,
            message: '请输入用户名!',
            validator: 'click'
          }]
        },
        password: {
          rules: [{
            required: true,
            message: '请输入密码!',
            validator: 'click'
          }]
        },
        mobile: {
          rules: [{
            validator: this.validateMobile
          }]
        } // captcha:{rule: [{ required: true, message: '请输入验证码!'}]},
        // inputCode:{rules: [{ required: true, message: '请输入验证码!'},{validator: this.validateInputCode}]}

      },
      verifiedCode: '',
      inputCodeContent: '',
      inputCodeNull: true,
      departList: [],
      departVisible: false,
      departSelected: '',
      currentUsername: '',
      validate_status: '',
      tenantId: 0
    };
  },
  created: function created() {
    Vue.ls.remove(ACCESS_TOKEN);
    this.getRouterData(); // update-begin- --- author:scott ------ date:20190225 ---- for:暂时注释，未实现登录验证码功能
    //      this.$http.get('/auth/2step-code')
    //        .then(res => {
    //          this.requiredTwoStepCaptcha = res.result.stepCode
    //        }).catch(err => {
    //          console.log('2step-code:', err)
    //        })
    // update-end- --- author:scott ------ date:20190225 ---- for:暂时注释，未实现登录验证码功能
    // this.requiredTwoStepCaptcha = true

    var reg = new RegExp('(^|&)tenant=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg); // console.log(unescape(r))
    // if (r) {

    this.setTenantInfo(unescape(r && r[2] ? r[2] : 0)); // }
  },
  beforeDestroy: function beforeDestroy() {
    this.timeout || clearTimeout(this.timeout);
  },
  methods: _objectSpread(_objectSpread({
    setTenantInfo: function setTenantInfo(id) {
      var isLogin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (isLogin) this.loginBtn = true;
      this.tenantId = id;
      this.getProjectInfo(id, isLogin);
    },
    getTenantByUsername: function getTenantByUsername() {
      var _this = this;

      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(function () {
        _this.getTenantInfo();
      }, 3 * 1000);
    },
    getTenantInfo: function getTenantInfo() {
      var _this2 = this;

      var isLogin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      console.log('getTenantInfo', isLogin);

      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.isLogin = isLogin;
      var formData = this.form.getForm().getFieldsValue();

      if (formData.username) {
        getAction("/auth/getTenantByUserName?userName=".concat(formData.username)).then(function (data) {
          if (data.success) {
            _this2.setTenantInfo(data.result.id, isLogin);
          } else {
            _this2.$notification_custom({
              message: data.message,
              type: 'warning',
              duration: 1
            });
          }
        });
      } else {
        var r = window.location.search.substr(1).match(new RegExp('(^|&)tenant=([^&]*)(&|$)'));
        this.setTenantInfo(unescape(r && r[2] ? r[2] : 0), isLogin);
      }
    },
    getProjectInfo: function getProjectInfo(id, isLogin) {
      var _this3 = this;

      var that = this;
      getAction('/sys/tenant/name/' + id).then(function (res) {
        if (res.success) {
          that.titleLogo = res.result.topLogo ? that.getImage(res.result.topLogo) : '';
          that.loginImg = res.result.homeLogo ? that.getImage(res.result.homeLogo) : loginImg;
          that.waterName = res.result.projectName || '智慧环境大数据平台'; // 海洋租户去除登录页二维码

          that.appQr = res.result.appQr ? that.getImage(res.result.appQr) : res.result.code != 'sea' ? sx_code : '';
          window.localStorage.setItem('waterName', that.waterName);
          window.localStorage.setItem('titleLogo', that.titleLogo);
          window.localStorage.setItem('copyright', res.result.copyright);
          window.localStorage.setItem('mapCenter', res.result.mapCenter);
          window.localStorage.setItem('mapZoom', res.result.zoomLevel); // 租户的信息进行缓存start

          window.localStorage.setItem('tenantMapCenter', res.result.mapCenter);
          window.localStorage.setItem('tenantMapZoom', res.result.zoomLevel); // 租户的信息进行缓存end

          window.localStorage.setItem('projectCode', res.result.code);

          _this3.$store.commit('changeProject', res.result.code);

          window.localStorage.setItem('homeUrl', res.result.homeUrl);

          if (res.result.modelKey) {
            var modelData = JSON.parse(JSON.stringify(res.result.modelKey.split(',')[0]));
            var modelUrlData = JSON.parse(JSON.stringify(res.result.modelKey));
            var modelKey = modelData ? modelData.split('/').length > 0 ? modelData.split('/')[modelData.split('/').length - 1] : null : null;
            var sceneUrl = modelUrlData ? modelUrlData.split(',').length > 1 ? modelUrlData.split(',')[1] : 'https://www.skyray-water.com:4001/3d/api/scenes/' : 'https://www.skyray-water.com:4001/3d/api/scenes/';
            window.localStorage.setItem('appKey', modelKey);
            window.localStorage.setItem('sceneUrl', sceneUrl);
          }

          if (res.result.areaNameList) {
            window.localStorage.setItem('areaNameList', JSON.stringify(res.result.areaNameList));
          }

          if (res.result.areaRoot) {
            window.localStorage.setItem('areaRoot', res.result.areaRoot);
          }

          document.title = window.localStorage.getItem('waterName');

          if (res.result.code == 'sx') {
            _this3.isSx = true;
          } else {
            _this3.isSx = false;
          }

          that.$forceUpdate();
        }

        if (isLogin) {
          that.handleSubmit();
        }
      }).catch(function () {
        _this3.loginBtn = false;
      });
    },
    getImage: function getImage(url) {
      return window._CONFIG['domianURL'] + '/sys/common/file/view' + '/' + url;
    }
  }, mapActions(['Login', 'Logout', 'PhoneLogin', 'wechatLogin'])), {}, {
    // handler
    handleUsernameOrEmail: function handleUsernameOrEmail(rule, value, callback) {
      var regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;

      if (regex.test(value)) {
        this.loginType = 0;
      } else {
        this.loginType = 1;
      }

      callback();
    },
    handleTabClick: function handleTabClick(key) {
      this.customActiveKey = key; // this.form.resetFields()
    },
    handleSubmit: function handleSubmit() {
      var _this4 = this;

      this.loginBtn = true;
      var that = this;
      var loginParams = {
        tenantId: this.tenantId
      }; // 使用账户密码登陆

      that.form.validateFields(['username', 'password', 'inputCode'], {
        force: true
      }, function (err, values) {
        if (!err) {
          getAction('/auth/getEncryptedString', {}).then(function (res) {
            loginParams.username = values.username; //loginParams.password = md5(values.password)

            loginParams.type = 1;
            loginParams.password = encryption(values.password, res.result.key, res.result.iv);
            that.Login(loginParams).then(function (res) {
              // this.departConfirm(res)
              window.localStorage.setItem('tenant', res.result.userInfo.tenantId);

              _this4.loginSuccess();
            }).catch(function (err) {
              if (err.code == 400) {
                _this4.$refs.userPassword.show(err.result.userName, that.tenantId);
              }

              that.requestFailed(err);
            });
          }).catch(function (err) {
            that.requestFailed(err);
          });
        } else {
          _this4.loginBtn = false;
        }
      });
    },
    wechatLoginSuccess: function wechatLoginSuccess(res) {
      var _this5 = this;

      console.log('微信登录成功', res); // let loginParams = {
      // 	tenantId: this.tenantId
      // }
      // loginParams.username = res.result.username
      // //loginParams.password = md5(values.password)
      // loginParams.password = res.result.password

      this.wechatLogin(res).then(function (res) {
        // this.departConfirm(res)
        window.localStorage.setItem('tenant', res.result.userInfo.tenantId);

        _this5.loginSuccess();
      }).catch(function (err) {
        if (err.code == 400) {
          _this5.$refs.userPassword.show(err.result.userName, _this5.tenantId);
        }

        _this5.requestFailed(err);
      });
    },
    loginSuccess: function loginSuccess() {
      getAction('/sys/tenant/name/' + this.tenantId).then(function (res) {
        window.localStorage.setItem('mapCenter', res.result.mapCenter);
        window.localStorage.setItem('tenantRemark', res.result.remark);
      });
      this.$router.push({
        name: 'dashboard'
      });
      this.$notification.success({
        message: '欢迎',
        description: "".concat(timeFix(), "\uFF0C\u6B22\u8FCE\u56DE\u6765")
      });
    },
    cmsFailed: function cmsFailed(err) {
      var _this6 = this;

      this.$notification['error']({
        message: '',
        description: err,
        duration: 4
      });
      setTimeout(function () {
        _this6.loginBtn = false;
      }, 2000);
    },
    requestFailed: function requestFailed(err) {
      var _this7 = this;

      this.$notification['error']({
        message: '登录失败',
        description: ((err.response || {}).data || {}).message || err.message || '请求出现错误，请稍后再试',
        duration: 4
      });
      setTimeout(function () {
        _this7.loginBtn = false;
      }, 2000);
    },
    validateMobile: function validateMobile(rule, value, callback) {
      if (!value || new RegExp(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/).test(value)) {
        callback();
      } else {
        callback('您的手机号码格式不正确!');
      }
    },
    // validateInputCode(rule,value,callback){
    //   if(!value || this.verifiedCode==this.inputCodeContent){
    //     callback();
    //   }else{
    //     callback("您输入的验证码不正确!");
    //   }
    // },
    generateCode: function generateCode(value) {
      this.verifiedCode = value.toLowerCase();
    },
    inputCodeChange: function inputCodeChange(e) {
      this.inputCodeContent = e.target.value;

      if (!e.target.value || 0 == e.target.value) {
        this.inputCodeNull = true;
      } else {
        this.inputCodeContent = this.inputCodeContent.toLowerCase();
        this.inputCodeNull = false;
      }
    },
    getRouterData: function getRouterData() {
      var _this8 = this;

      this.$nextTick(function () {
        _this8.form.setFieldsValue({
          username: _this8.$route.params.username
        });
      });
    }
  })
};